import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 32px;
  padding: 32px 0 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    border: none;
    margin: 48px -48px 0;
    padding: 48px;
    display: flex;
    justify-content: space-between;

    background: linear-gradient(
      180deg,
      rgba(244, 248, 255, 1) 0%,
      rgba(244, 248, 255, 0) 100%
    );
  }
`;

export const ImageContainer = styled.div`
  display: none;
  position: relative;
  min-height: 496px;
  min-width: 380px;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: unset;
  }
`;

export const MainImage = styled.img`
  position: absolute;
  bottom: -96px;
  width: auto;
  height: 130%;
`;

export const TopTriangle = styled.img`
  position: absolute;
  z-index: 1;
  top: -24px;
  left: 0;
  width: 300px;
  height: 300px;
`;

export const BottomTriangle = styled.img`
  position: absolute;
  z-index: 1;
  bottom: -48px;
  right: 0;
  width: 300px;
  height: 300px;
`;

export const TitleFeedbacksWrapper = styled.div`
  font-family: "Inter", sans-serif;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 50%;
    min-height: 448px;
    height: 448px;
    max-height: 448px;
    overflow: hidden;
  }
`;

export const Title = styled.h2`
  font-size: ${24 / 16}rem;
  color: ${({ theme }) => theme.palette.black.default};
  font-weight: 700;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${32 / 16}rem;
  }
`;

export const Description = styled.p`
  margin-top: 16px;
  font-size: ${16 / 16}rem;
  opacity: 0.7;
  color: ${({ theme }) => theme.palette.black.default};

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${20 / 16}rem;
  }
`;

export const Feedback = styled.p`
  margin-top: 24px;
  font-size: ${14 / 16}rem;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.greyscale.grey600};

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${20 / 16}rem;
  }
`;

export const ClientName = styled.p`
  font-size: ${16 / 16}rem;
  font-family: "Plus Jakarta Sans";
  font-weight: 700;
  color: ${({ theme }) => theme.palette.black.default};
  margin-top: 24px;
  line-height: ${24 / 16}rem;

  & em {
    font-style: normal;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.greyscale.grey500};
  }
`;

export const ImagesWrapper = styled.div`
  margin-top: 24px;
  gap: 32px;
  display: flex;
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  width: ${48 / 16}rem;
  height: ${48 / 16}rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: ${80 / 16}rem;
    height: ${80 / 16}rem;
  }
`;

export const ProgressRingWrapper = styled.svg`
  width: ${48 / 16}rem;
  height: ${48 / 16}rem;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;

  &.active {
    opacity: 1;
    visibility: visible;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: ${80 / 16}rem;
    height: ${80 / 16}rem;
  }
`;

export const ProgressRing = styled.circle`
  --stroke-len: 226;
  fill: none;
  stroke-width: 4px;
  stroke: ${({ theme }) => theme.palette.black.default};
  stroke-dasharray: var(--stroke-len);
  stroke-dashoffset: var(--stroke-len);

  &.active {
    animation: progressRingAnim 5s linear forwards;
  }

  @keyframes progressRingAnim {
    100% {
      stroke-dashoffset: var(--stroke-len);
    }
    0% {
      stroke-dashoffset: 0;
    }
  }
`;

export const ClientImage = styled.img`
  width: 40px;
  height: 40px;
  opacity: 50%;
  cursor: pointer;

  &.active {
    opacity: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 72px;
    height: 72px;
  }
`;
